import { getStrings } from '../../../Common/Localization/commonStrings';

const localizedStrings = {
  twoFactorAuthenticationStrings: {
    strings: {
      en: {
        verify: 'Verify',
        verifyEmail: 'Verify this email',
        verifyPhone: 'Verify this number',
        VerifyYourEmailAddress: 'Verify Your Email Address',
        VerifyYourPhoneAddress: 'Verify Your Phone Number',
        VerifyYourEmailAddressSubText: 'We will send a verification code that you’ll need to enter on the next screen. ',
        VerifyYourPhoneNumberSubText: 'Choose how you want to receive this code.',
        emailVerified: 'Your Email Address has been verified.',
        phoneVerified: 'Your phone number has been verified.',
        enterVerificationCodeReceived: 'Enter the 6-digit verification code you received from us.',
        enterVerificationCodeReceivedLandline: 'Enter the 5-digit verification code you received from us and select your phone type.',
        enterVerificationCode: 'Enter Verification Code',
        verificationCode: 'Verification Code',
        resendCode: 'Resend code',
        phonetype: 'Phone Type',
        continue: 'Continue',
        textMe: 'Text Me',
        callMe: 'Call Me',
        limitExceedErrorMsg: 'You have temporarily exceeded the resend-code limit. Please try again in 30 minutes.',
        mobile: 'Mobile',
        landline: 'Landline',
        invalidVerifyCode: 'The code is invalid or expired. Request a new code below.', 
        tryAgain: 'We were unable to resend your code. Please try again after 1 minute.',
      },
      es: {
      }
    },
    common: ['globalError']
  },
};
export const getLocalizedStrings = (componentName) => {
  app.logger.getLogger().debug("Comp Name" + componentName);
  var strings = getStrings(localizedStrings[componentName].strings,
    localizedStrings[componentName].common, true);
  return strings;
};
